































































































































































































































































































































































































































































































































































































































































import Card from '@/components/UI/Card.vue';
import CollapseCard from '@/components/UI/CollapseCard.vue';
import '@/extensions';
import {
    CalcIndividualConfig,
    IndividualConfig,
    SaleIndividualConfig,
    SaleServerIndividualConfig,
    SelectBox
} from '@/interfaces/global-data';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import ColumnTitleContent from '@/components/UI/Table/ColumnTitleContent.vue';
import {
    ISale,
    ISaleResponseDto,
    ISaleTableItem,
    ISaleFiltersInLevels,
    ISaleStaticTableFilterOptions
} from "@/pages/Sales/data";
import SalesApi from "@/pages/Sales/SalesApi";
import moment from "moment";
import {SalesCalculationFilters, SalesFilters} from "@/interfaces/server-data";
import {Modal} from "ant-design-vue";

@Component({
    components: {
        vSelect,
        CollapseCard,
        Card,
        ColumnTitleContent,
    },
})

export default class SalesListTable extends Mixins(LocalData, Http) {
    @Prop({required: true}) readonly filters!: ISaleFiltersInLevels;
    @Prop({required: true}) readonly api!: SalesApi;

    get tableFilterValuesToBeWatched () {
        return Object.assign({}, this.tableFilterValues)
    }

    private someFiltersStates: any = {
        groupIds: [],
        categoryIds: [],
        subcategoryId: null,
        formatId: null,
        regionIds: [],
        clusterIds: [],
    };

    @Watch('tableFilterValuesToBeWatched',{deep: true})
    onTableFilterValuesChanged(value: any, oldValue: any) {
        this.someFiltersStates.groupIds = value.groupIds;
        this.someFiltersStates.categoryIds = value.categoryIds;
        this.someFiltersStates.subcategoryId = value.subcategoryId;
        this.someFiltersStates.formatId = value.formatId;
        this.someFiltersStates.regionIds = value.regionIds;
        this.someFiltersStates.clusterIds = value.clusterIds;

        if (!LocalData.compareTwoArrays(value.groupIds, oldValue.groupIds)) {
            if (!!this.filters.groupIds.length && !LocalData.compareTwoArrays(value.groupIds, this.filters.groupIds)) {
                this.$emit('reset-filters', true);
                return;
            }
        }

        if (!LocalData.compareTwoArrays(value.categoryIds, oldValue.categoryIds)) {
            if (!!this.filters.categoryIds.length && !LocalData.compareTwoArrays(value.categoryIds, this.filters.categoryIds)) {
                this.$emit('reset-filters', true);
                return;
            }
        }

        if (value.subcategoryId !== oldValue.subcategoryId) {
            if (oldValue.subcategoryId !== -1 && value.subcategoryId !== this.filters.subcategory) {
                this.$emit('reset-filters', true);
                return;
            }
        }

        if (value.formatId !== oldValue.formatId) {
            if (oldValue.formatId !== -1 && value.formatId !== this.filters.formatSelected) {
                this.$emit('reset-filters', true);
                return;
            }
        }

        if (!LocalData.compareTwoArrays(value.regionIds, oldValue.regionIds)) {
            if (!!this.filters.regionIds.length && !LocalData.compareTwoArrays(value.regionIds, this.filters.regionIds)) {
                this.$emit('reset-filters', true);
                return;
            }
        }

        if (!LocalData.compareTwoArrays(value.clusterIds, oldValue.clusterIds)) {
            if (!!this.filters.clusterIds.length && !LocalData.compareTwoArrays(value.clusterIds, this.filters.clusterIds)) {
                this.$emit('reset-filters', true);
                return;
            }
        }
    }

    private defaultTableState = {
        sortField: 'id',
        isAsc: false,
        page: 0,
        size: 10,
    };

    private tableState = {
        sortField: 'id',
        isAsc: false,
        page: 0,
        size: 10,
    };

    staticTableFilterOptions: ISaleStaticTableFilterOptions = {
        statuses: [
            {
                value: 'ACTIVE',
                label: this.$t('salesListTab.statuses.active') as string,
            },
            {
                value: 'STOPPED',
                label: this.$t('salesListTab.statuses.stopped') as string,
            },
            {
                value: 'PLANNED',
                label: this.$t('salesListTab.statuses.planned') as string,
            },
        ],
        types: [
            {
                value: 'SALE',
                label: this.$t('salesListTab.saleTypes.SALE') as string
            },
            {
                value: 'FLASH_SALE',
                label: this.$t('salesListTab.saleTypes.BOMB') as string
            },
            {
                value: 'MARKDOWN',
                label: this.$t('salesListTab.saleTypes.WITHDRAWAL') as string
            },
            {
                value: 'DISCONTINUED',
                label: this.$t('salesListTab.saleTypes.DISCOUNT') as string
            },
            {
                value: 'SEASONAL',
                label: this.$t('salesListTab.saleTypes.SEASON') as string
            },
        ],
    };

    private tableFilterOptions = {};

    private defaultTableFilterValues = {
        id: null,
        name: null,
        types: [],
        startDate: null,
        endDate: null,
        remains: null,
        stagesNumber: null,
        statuses: [],
        minSaleDiscount: null,
        maxSaleDiscount: null,
        minMargin: null,
        groupIds: [],
        categoryIds: [],
        // subcategoryIds: [],
        subcategoryId: null,
        // formatIds: [],
        formatId: null,
        regionIds: [],
        // regionId: null,
        clusterIds: [],
        // clusterId: null,
    };

    private tableFilterValues: any = {
        id: null,
        name: null,
        types: [],
        startDate: null,
        endDate: null,
        remains: null, // нет фильрации на бэке
        stagesNumber: null,
        statuses: [],
        minSaleDiscount: null,
        maxSaleDiscount: null,
        minMargin: null,
        groupIds: [],
        categoryIds: [],
        // subcategoryIds: [],
        subcategoryId: null,
        // formatIds: [],
        formatId: null,
        regionIds: [],
        // regionId: null,
        clusterIds: [],
        // clusterId: null,
    };

    private saleSelectBaseFormatFilter: number = 1;

    defaultFilterValue = {value: -1, label: this.$t('salesListTab.filters.all') as string};
    defaultStringFiltersValue = {value: null, label: this.$t('salesListTab.filters.all') as string};

    private selectDependFormatFilter: number = this.defaultFilterValue.value;
    private formatDependFilterOptions: Array<SelectBox<number>> = [];

    private selectBaseFormatFilter: number = this.defaultFilterValue.value;
    private formatBaseFilterOptions: Array<SelectBox<number>> = [];

    private selectBaseRegionFilter: number = this.defaultFilterValue.value;
    private regionBaseFilterOptions: Array<SelectBox<number>> = [];

    private selectBaseClusterFilter: number = this.defaultFilterValue.value;
    private clusterBaseFilterOptions: Array<SelectBox<number>> = [];

    private selectDependRegionFilter: number = this.defaultFilterValue.value;
    private regionDependFilterOptions: Array<SelectBox<number>> = [];

    private selectDependClusterFilter: number = this.defaultFilterValue.value;
    private clusterDependFilterOptions: Array<SelectBox<number>> = [];

    private selectOmnichannelGap: number = this.defaultFilterValue.value;
    private gapFilterOptions: Array<SelectBox<number>> = [];

    private selectApplyForPriceSegments: boolean | null = this.defaultStringFiltersValue.value;
    private applyForPriceSegmentsFilterOptions: Array<SelectBox<boolean | null>> = [];

    private selectApplyCompetitorPrices: boolean | null = this.defaultStringFiltersValue.value;
    private applyCompetitorPricesFilterOptions: Array<SelectBox<boolean | null>> = [];

    private selectApplyMinProfitabilityLimit: boolean | null = this.defaultStringFiltersValue.value;
    private applyMinProfitabilityLimitFilterOptions: Array<SelectBox<boolean | null>> = [];

    private selectOmnichannelTopEdgeFilter: number = this.defaultFilterValue.value;
    private topEdgeFilterOptions: Array<SelectBox<number>> = [];

    private selectOmnichannelBottomEdgeFilter: number = this.defaultFilterValue.value;
    private bottomEdgeFilterOptions: Array<SelectBox<number>> = [];

    private selectOmnichannelDepthFilter: number = this.defaultFilterValue.value;
    private depthFilterOptions: Array<SelectBox<number>> = [];

    private omnichannelTotalRows: number = 0;

    private newTableFields: any[] = [
        {
            dataIndex: 'id',
            slots: { title: 'idColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$tc('sales.table.headers.id'),
            },
            align: 'center',
            fixed: 'left',
            width: 76,
            ellipsis: true,
            filterModel: 'id',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon",
            },
        },
        {
            dataIndex: 'startDate',
            slots: { title: 'startDateColumnTitle' },
            slotColumnTitleData: {
                text: this.$tc('sales.table.headers.startDate'),
            },
            sorter: true,
            width: 184,
            ellipsis: true,
            // align: 'center',
            filterModel: 'startDate',
            // disabledDateMethod: current => current && new Date(current) < new Date().setUTCHours(0,0,0,0),
            disabledDateMethod: () => {},
            scopedSlots: {
                filterDropdown: 'filterDatepicker',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'endDate',
            slots: { title: 'endDateColumnTitle' },
            slotColumnTitleData: {
                text: this.$tc('sales.table.headers.endDate'),
            },
            sorter: true,
            width: 184,
            ellipsis: true,
            filterModel: 'endDate',
            // disabledDateMethod: current => current && new Date(current) < new Date().setUTCHours(0,0,0,0),
            scopedSlots: {
                filterDropdown: 'filterDatepicker',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'name',
            slots: { title: 'nameColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$tc('sales.name'),
            },
            sorter: true,
            width: 250,
            ellipsis: true,
            filterModel: 'name',
            scopedSlots: {
                filterDropdown: 'filterInputTextCommon',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'type',
            slots: { title: 'typeColumnTitle' },
            slotColumnTitleData: {
                text: this.$tc('sales.type'),
            },
            sorter: true,
            width: 190,
            ellipsis: true,
            filterOptions: 'types',
            filterModel: 'types',
            scopedSlots: {
                customRender: 'type',
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
        },
        {
            dataIndex: 'status',
            slots: { title: 'statusColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$tc('sales.table.headers.statusColumn.headerName'),
            },
            sorter: true,
            filterOptions: 'statuses',
            filterModel: 'statuses',
            scopedSlots: {
                customRender: 'status',
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
                title: 'titleCustom',
            },
            width: 140,
            ellipsis: true,
        },
        {
            dataIndex: 'groups',
            slots: { title: 'groupsColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$tc('shared.filters.groupOfProduct'),
            },
            width: 170,
            ellipsis: true,
            filterOptions: 'groups',
            filterModel: 'groupIds',
            scopedSlots: {
                customRender: 'arrayOfIdAndNames',
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
        },
        {
            dataIndex: 'categories',
            slots: { title: 'categoriesColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$tc('shared.filters.categoryOfProduct'),
            },
            width: 200,
            ellipsis: true,
            filterOptions: 'categories',
            filterModel: 'categoryIds',
            scopedSlots: {
                customRender: 'arrayOfIdAndNames',
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
        },
        {
            dataIndex: 'subcategory.name',
            slots: { title: 'subcategory.nameColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$tc('shared.filters.subcategories'),
            },
            customRender: this.nameFormatter,
            width: 240,
            ellipsis: true,
            filterOptions: 'subcategories',
            filterModel: 'subcategoryId',
            scopedSlots: {
                filterDropdown: 'filterRadioButtons',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'format.name',
            slots: { title: 'format.nameColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$tc('shared.filters.storeFormat'),
            },
            width: 200,
            ellipsis: true,
            filterOptions: 'storeFormats',
            filterModel: 'formatId',
            scopedSlots: {
                filterDropdown: 'filterRadioButtons',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'regions',
            slots: { title: 'regionsColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$tc('shared.filters.storeRegion'),
            },
            // sorter: true,
            width: 200,
            ellipsis: true,
            filterOptions: 'storeRegions',
            filterModel: 'regionIds',
            scopedSlots: {
                customRender: 'arrayOfIdAndNames',
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
        },
        {
            dataIndex: 'clusters',
            slots: { title: 'clustersColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$tc('shared.filters.storeCluster'),
            },
            // sorter: true,
            width: 200,
            ellipsis: true,
            filterOptions: 'storeClusters',
            filterModel: 'clusterIds',
            scopedSlots: {
                customRender: 'arrayOfIdAndNames',
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'skuCount',
            slots: { title: 'skuCountColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$tc('sales.table.headers.skuCount'),
            },
            sorter: true,
            customRender: this.valueUnknown,
            width: 180,
            ellipsis: true,
            filterModel: 'skuCount',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'remains',
            slots: { title: 'remainsColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$tc('sales.table.headers.remains'),
            },
            sorter: true,
            customRender: this.valueUnknown,
            width: 120,
            ellipsis: true,
            filterModel: 'remains',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'taskId',
            slots: { title: 'taskIdColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$tc('sales.table.headers.taskId'),
            },
            sorter: true,
            width: 170,
            filterModel: 'taskId',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'stagesNumber',
            slots: { title: 'stagesNumberColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$tc('sales.table.headers.stagesNumber'),
            },
            width: 200,
            ellipsis: true,
            sorter: true,
            filterModel: 'stagesNumber',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'minSaleDiscount',
            slots: { title: 'minSaleDiscountColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$tc('sales.table.headers.minSaleDiscount'),
            },
            width: 200,
            ellipsis: true,
            sorter: true,
            filterModel: 'minSaleDiscount',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'maxSaleDiscount',
            slots: { title: 'maxSaleDiscountColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$tc('sales.table.headers.maxSaleDiscount'),
            },
            width: 200,
            ellipsis: true,
            sorter: true,
            filterModel: 'maxSaleDiscount',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'minMargin',
            slots: { title: 'minMarginColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$tc('sales.table.headers.minMargin'),
            },
            width: 160,
            ellipsis: true,
            sorter: true,
            filterModel: 'minMargin',
            scopedSlots: {
                filterDropdown: 'filterInputNumberCommon',
                filterIcon: "filterIcon"
            },
        },
        {
            dataIndex: 'actions',
            title: this.$tc('shared.labels.actions'),
            scopedSlots: { customRender: 'actions' },
            fixed: 'right',
            width: 180,
        },
    ];

    pagination: any = {
        current: 1,
        pageSize: 10,
        total: 0,
    }

    tableItems: Array<ISaleTableItem> = [];

    isTableLoading: boolean = false;

    private sortingFieldNames: { [key: string]: string } = {
        'groups': 'groupId',
        'categories': 'categoryId',
        'subcategory.name': 'subcategoryId',
        'format.name': 'formatId',
        'regions': 'regionId',
        'clusters': 'clusterId',
    };

    onTableChange(pagination: {current: number, pageSize: number}, filters: any, sorter: {order: string, field: string}) {
        if (sorter.field && sorter.order) {
            if (this.tableState.sortField && this.tableState.sortField !== 'id') { // this optimization, because on this page - impossible sort by id, and id is default (if possible sort by id - remove second condition)
                this.newTableFields.find(column => (this.sortingFieldNames[column.dataIndex] || column.dataIndex) === this.tableState.sortField).sortOrder = false;
            }

            this.newTableFields.find(column => column.dataIndex === sorter.field).sortOrder = sorter.order;

            this.tableState.sortField = this.sortingFieldNames[sorter.field] || sorter.field;
            this.tableState.isAsc = sorter.order === 'ascend';
        } else {
            this.newTableFields.forEach(column => {
                if (column.sortOrder) {
                    column.sortOrder = false;
                }
            })

            this.tableState.sortField = 'id';
            this.tableState.isAsc = false;
        }

        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;

        this.tableState.page = pagination.current - 1;
        this.tableState.size = pagination.pageSize;

        this.fetchSales();
    }

    fetchData(ignoreFilters: boolean = false) {
        if (this.filters.groupIds.length) {
            this.tableFilterValues.groupIds = this.filters.groupIds;
        } else {
            if (!ignoreFilters) {
                this.tableFilterValues.groupIds = [];
            } else {
                this.tableFilterValues.groupIds = this.someFiltersStates.groupIds || [];
            }
        }

        if (this.filters.categoryIds.length) {
            this.tableFilterValues.categoryIds = this.filters.categoryIds;
        } else {
            if (!ignoreFilters) {
                this.tableFilterValues.categoryIds = [];
            } else {
                this.tableFilterValues.categoryIds = this.someFiltersStates.categoryIds || [];
            }
        }

        if (this.filters.subcategory !== -1) {
            this.tableFilterValues.subcategoryId = this.filters.subcategory;
        } else {
            if (!ignoreFilters) {
                this.tableFilterValues.subcategoryId = null;
            } else {
                this.tableFilterValues.subcategoryId = this.someFiltersStates.subcategoryId || null;
            }
        }

        if (this.filters.formatSelected !== -1) {
            this.tableFilterValues.formatId = this.filters.formatSelected;
        } else {
            if (!ignoreFilters) {
                this.tableFilterValues.formatId = null;
            } else {
                this.tableFilterValues.formatId = this.someFiltersStates.formatId || null;
            }
        }

        if (this.filters.regionIds.length) {
            this.tableFilterValues.regionIds = this.filters.regionIds;
        } else {
            if (!ignoreFilters) {
                this.tableFilterValues.regionIds = [];
            } else {
                this.tableFilterValues.regionIds = this.someFiltersStates.regionIds;
            }
        }

        if (this.filters.clusterIds.length) {
            this.tableFilterValues.clusterIds = this.filters.clusterIds;
        } else {
            if (!ignoreFilters) {
                this.tableFilterValues.clusterIds = [];
            } else {
                this.tableFilterValues.clusterIds = this.someFiltersStates.clusterIds;
            }
        }

        this.fetchSales(ignoreFilters);
        this.fetchFilterOptions((this.filters.market && this.filters.market.id) || this.$sales.selectMarket.id);
    }

    private nameFormatter(name: string | null): string {
        if (name != null) {
            return name
        }
        return this.$tc('shared.selectBox.all');
    }

    private valueUnknown(name: string | null | number): string | null | number {
        if (name != -1) {
            return name
        }
        return this.$t('salesListTab.messages.unknownType') as string;
    }

    mounted() {
        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.fetchSales();
        this.fetchFilterOptions((this.filters.market && this.filters.market.id) || this.$sales.selectMarket.id);
    }

    private toYesOrNoOmnichannel(value: boolean | null): string {
        if (value === null) {
            return ' '
        } else if (value) {
            return this.$t('shared.buttons.yes') as string
        } else {
            return this.$t('shared.buttons.no') as string
        }
    }

    private getFilterObjectWithServerFields(
        filterObject: { [key: string]: string | number | boolean | null }
    ): Record<string, string | number | boolean | null> {
        const serverFieldNames: Record<string, string> = {
            'statuses': 'status',
            'types': 'type',
            'groupIds': 'groupId',
            'categoryIds': 'categoryId',
            'regionIds': 'regionId',
            'clusterIds': 'clusterId',
            // 'subcategoryIds': 'subcategoryId', // в бэке только одна
            // 'formatIds': 'formatId', // в бэке только один
        };

        const resultObj: Record<string, string | number | boolean | null> = {};

        Object.keys(filterObject).forEach(filterKey => {
            resultObj[serverFieldNames[filterKey] || filterKey] = filterObject[filterKey];
        });

        return resultObj;
    }

    private resetSalesTableFilters() {
        this.$emit('reset-filters');

        this.tableFilterValues = Object.assign({}, this.defaultTableFilterValues);
        this.someFiltersStates = {};

        this.pagination.current = 1;

        this.tableState = Object.assign({}, this.defaultTableState);

        this.fetchSales();
    }

    private fetchSales(ignoreFilters: boolean = false) {
        if (!(this.filters.market && this.filters.market.id) || !this.$sales.selectMarket.id) {
            return;
        }

        this.isTableLoading = true;

        const usualParams = {
          page: 0,
          size: 10,
          tradingId: (this.filters.market && this.filters.market.id) || this.$sales.selectMarket.id,
          ...this.tableState,
        };

        const timezoneOffset: number = (new Date()).getTimezoneOffset() * 60000;

        const filters = !ignoreFilters ?
            this.getFilterObjectWithServerFields({
                ...this.tableFilterValues,
                startDate: this.tableFilterValues.startDate ? new Date (new Date(this.tableFilterValues.startDate as string).getTime() - timezoneOffset).toISOString().slice(0, 10): null,
                endDate: this.tableFilterValues.endDate ? new Date (new Date(this.tableFilterValues.endDate as string).getTime() - timezoneOffset).toISOString().slice(0, 10): null,
            })
            : {};

        this.api.fetchSalesWithFilters(filters, usualParams)
            .then((resp) => {
                if (resp.status === 200) {
                    const array: ISaleTableItem[] = []
                    resp.data.content.forEach((e: ISaleResponseDto) => {
                        array.push({
                            id: e.id,
                            tradingId: e.tradingId,
                            groups: e.groups,
                            categories: e.categories,
                            subcategory: e.subcategory,
                            clusters: e.clusters,
                            format: e.format,
                            regions: e.regions,
                            type: e.type,
                            status: e.status,
                            skuCount: e.skuCount,
                            remains: e.remains,
                            taskId: e.taskId,
                            startDate: e.startDate,
                            endDate: e.endDate,
                            name: e.name,
                            stagesNumber: e.stagesNumber,
                            minSaleDiscount: e.minSaleDiscount,
                            maxSaleDiscount: e.maxSaleDiscount,
                            minMargin: e.minMargin,
                            considerPlannedSeason: false, // временно, после доработок по бэку убрать and uncomment below
                            revaluationFileName: e.revaluationFileName
                            // considerPlannedSeason: e.considerPlannedSeason,
                        })
                    })

                    this.tableItems = Object.assign([], array);

                    this.pagination.total = resp.data.totalElements;
                }
            })
            .catch(() => {
                this.showError(this.$t('salesListTab.messages.errorLoadSales') as string);
            })
            .finally(() => {
                this.isTableLoading = false;
            })
    }

    private fetchFilterOptions(tradingId: number) {
        if ((!this.filters.market || this.filters.market.id == null) && !this.$sales.selectMarket.id) {
            return;
        }
        this.api.fetchFilterOptions(tradingId)
            .then((resp: any) => {
                if (resp.status === 200) {
                    const filterOptions: { [key: string]: Array<{value: number | string, label: string}> } = {};

                    Object.keys(resp.data).forEach(key => {
                        if (['statuses', 'types'].includes(key)) {
                            filterOptions[key] = this.staticTableFilterOptions[key as keyof ISaleStaticTableFilterOptions].filter(item => resp.data[key].includes(item.value));
                        } else {
                            filterOptions[key] = resp.data[key].map((option: {id: number, name: string}) => {
                                return {
                                    value: option.id,
                                    label: option.name
                                }
                            });
                        }
                    });

                    this.tableFilterOptions = filterOptions;
                }
            })
            .catch(() => {
                this.showError(this.$t('salesListTab.messages.errorLoadOptions') as string);
            })
    }

    private openParametersTab(isExpanded: boolean, sale: ISale) {
        this.$emit('open-params-tab', sale);
    }

    private handelDeleteSale(sale: ISaleTableItem) {
        Modal.confirm({
            title: this.$tc('shared.messages.attention'),
            content: this.$tc('sales.deleteConfirmText'),
            centered: true,
            okText: this.$tc('shared.buttons.yes'),
            cancelText: this.$tc('shared.buttons.no'),
            onOk: () => {
                if (sale.id != null) {
                    this.api.deleteSale(sale.id)
                        .then((resp) => {
                            if (resp.status === 200) {
                                this.showInfo(this.$t('salesListTab.messages.infoDeleteSuccess') as string);
                                this.$emit('sale-deleted', sale.id);
                            }
                        })
                        .catch(() => {
                            this.showError(this.$t('salesListTab.messages.errorDelete') as string);
                        });
                }
            },
        });
    }

    isValidDate(dateString: string, format: string = "YYYY-MM-DD") {
        return moment(dateString, format, true).isValid();
    }

    isValidPlanningPromoPeriod(sale: ISaleTableItem): boolean {
        if (!this.isValidDate(sale.startDate as string)
            || !this.isValidDate(sale.endDate as string)
        ) {
            return false;
        }

        const startDate = moment(sale.startDate as string)
        const endDate = moment(sale.endDate as string)

        return !endDate.isBefore(startDate, 'days');
    }

    handleCalculateBtnClick(sale: ISaleTableItem) {
        Modal.confirm({
            title: this.$t('salesListTab.messages.confirmStartCalcTitle') as string,
            content: this.$t('salesListTab.messages.confirmStartCalcContent', { id: sale.id, name: sale.name }) as string,
            centered: true,
            okText: this.$t('salesListTab.messages.okStart') as string,
            cancelText: this.$t('salesListTab.messages.cancel') as string,
            onOk: () => {
                this.salesCalculationStart(sale);
            },
        });
    }

    handleCreateScheduleBtnClick(sale: ISaleTableItem) {
        Modal.confirm({
            title: this.$t('salesListTab.messages.confirmCreateScheduleTitle') as string,
            content: this.$t('salesListTab.messages.confirmCreateScheduleContent', { id: sale.id, name: sale.name }) as string,
            centered: true,
            okText: this.$t('salesListTab.messages.okCreate') as string,
            cancelText: this.$t('salesListTab.messages.cancel') as string,
            onOk: () => {
                this.createScheduleFromSale(sale);
            },
        });
    }

    salesCalculationStart(sale: ISaleTableItem) {
        if (!this.isValidPlanningPromoPeriod(sale)) {
            this.showError(this.$t('salesListTab.messages.invalidPlannedPeriod') as string)
            return;
        }

        const data = this.getSalesFilter(sale);

        this.httpPackageSalesCalculationStart({
            ...data,
            saleId: sale.id,
            minProfitability: sale.minMargin,
            maxProfitability: data.maxMarginalProfit != null ? data.maxMarginalProfit : 100,
            minDiscount: sale.minSaleDiscount,
            maxDiscount: sale.maxSaleDiscount,
            stagesNumber: sale.stagesNumber,
            startDate: !!sale.startDate
                ? moment.utc(sale.startDate).startOf('day').valueOf()
                : null,
            endDate: !!sale.endDate
                ? moment.utc(sale.endDate).startOf('day').valueOf()
                : null,
        } as SalesCalculationFilters)
            .then((r) => {
                    this.showInfo((this.$t('salesListTab.messages.infoStartCalcSuccess', { name: sale.name }) as string));
                    this.$log.debug('Create task', r.data);
                },
            )
            .catch(() => {
                this.showError((this.$t('salesListTab.messages.errorStartCalc', { name: sale.name }) as string));
            });
    }

    createScheduleFromSale(sale: ISaleTableItem) {
        if (!this.isValidPlanningPromoPeriod(sale)) {
            this.showError(this.$t('salesListTab.messages.invalidPlannedPeriod') as string);
            return;
        }

        if (!sale.stagesNumber || sale.stagesNumber < 2) {
            this.showError(this.$t('salesListTab.messages.minStagesError') as string);
            return;
        }

        this.api.createScheduleFromSale(sale.id!)
            .then((response) => {
                this.showInfo((this.$t('salesListTab.messages.infoScheduleCreated', { name: sale.name, details: response.data }) as string));
                this.$log.debug('Schedule created', response.data);
            })
            .catch((error) => {
                const errorMessage = error.response.data || this.$t('salesListTab.messages.errorCreateSchedule') as string;
                this.showError((this.$t('salesListTab.messages.errorScheduleCreate', { name: sale.name, details: errorMessage }) as string));
            });
    }

    getSelectData(): [number[], number[], string[]] {
        const selectSeasons: number[] = (this.$sales.seasonSelected.length === 0 || (this.$sales.seasonSelected.length === 1 && this.$sales.seasonSelected[0] === 0))
            ? []
            : LocalData.filterNumberArrays(this.$sales.seasonSelected)!!;

        const selectBuyerSegment: number[] = (this.$sales.buyerSegmentsList.length === 0 || (this.$sales.buyerSegmentsList.length === 1 && this.$sales.buyerSegmentsList[0] === 0))
            ? []
            : LocalData.filterNumberArrays(this.$sales.buyerSegmentsList)!!;

        const selectedSku: string[] = (this.$sales.selectedSkuList.length === 0 || this.$sales.selectedSkuList.length === 1 && this.$sales.selectedSkuList[0].value === null)
            ? []
            : (this.$sales.selectedSkuList).filter((item) => item.value !== null).map((item) => {
                return (item.value);
            });

        return [selectSeasons, selectBuyerSegment, selectedSku];
    }

    prepareIndividualConfig(config: SaleIndividualConfig): SaleServerIndividualConfig {
        const prepared: SaleServerIndividualConfig = {};

        if ('minPrice' in config && typeof config.minPrice !== 'undefined' && config.minPrice != null) {
            prepared.minPrice = config.minPrice;
        }

        if ('maxPrice' in config && typeof config.maxPrice !== 'undefined' && config.maxPrice != null) {
            prepared.maxPrice = config.maxPrice;
        }

        if ('minProfitability' in config && typeof config.minProfitability !== 'undefined' && config.minProfitability != null) {
            prepared.minProfitability = config.minProfitability;
        }

        if ('minDiscount' in config && typeof config.minDiscount !== 'undefined' && config.minDiscount != null) {
            prepared.minDiscount = config.minDiscount;
        }

        if ('maxDiscount' in config && typeof config.maxDiscount !== 'undefined' && config.maxDiscount != null) {
            prepared.maxDiscount = config.maxDiscount;
        }

        if ('remains' in config && typeof config.remains !== 'undefined' && config.remains != null) {
            prepared.remains = config.remains;
        }

        return prepared;
    }

    prepareCommonIndividualConfig(config: IndividualConfig): CalcIndividualConfig {
        const prepared: CalcIndividualConfig = {};

        if ('kviStrategy' in config && typeof config.kviStrategy !== 'undefined' && config.kviStrategy !== null) {
            prepared.kviStrategy = config.kviStrategy.value
        }

        if ('marginalProfit' in config && typeof config.marginalProfit !== 'undefined' && config.marginalProfit != null) {
            prepared.marginalProfit = config.marginalProfit;
        }

        if ('selectCoefficent' in config && typeof config.selectCoefficent !== 'undefined' && config.selectCoefficent !== null) {
            const coef = config.selectCoefficent;
            prepared.coefficientK1 = coef.value.k1;
            prepared.coefficientK2 = coef.value.k2;
            prepared.priceOpt = coef.value.enum;
        }

        if ('priceIncreaseLimit' in config && typeof config.priceIncreaseLimit !== 'undefined' && config.priceIncreaseLimit != null) {
            prepared.priceIncreaseLimit = config.priceIncreaseLimit;
        }

        if ('competitorsPricesParams' in config && typeof config.competitorsPricesParams !== 'undefined' && config.competitorsPricesParams != null) {
            prepared.competitorsPricesParams = config.competitorsPricesParams;
        }

        if ('percentageOfCompetitorsPrice' in config) {
            prepared.percentageOfCompetitorsPrice = config.percentageOfCompetitorsPrice;
        }

        if ('periodPriceIncreaseLimit' in config && typeof config.periodPriceIncreaseLimit !== 'undefined' && config.periodPriceIncreaseLimit != null) {
            prepared.periodPriceIncreaseLimit = config.periodPriceIncreaseLimit;
        }

        if ('period' in config && typeof config.period !== 'undefined' && config.period !== null) {
            prepared.period = config.period.value;
        }

        if ('newProductPriceStrategy' in config && typeof config.newProductPriceStrategy !== 'undefined' && config.newProductPriceStrategy !== null) {
            prepared.newProductPriceStrategy = config.newProductPriceStrategy.value;
        }

        if ('priceGap' in config && typeof config.priceGap !== 'undefined' && config.priceGap != null) {
            prepared.priceGap = config.priceGap;
        }

        return prepared;
    }

    getSalesFilter(sale: ISaleTableItem): SalesFilters {
        const [selectSeasons, selectBuyerSegment, selectedSku] = this.getSelectData();
        const allCheck = this.$sales.allCheck;
        // const pennies = this.$sales.pennies;
        const countAtLastPurchasePrice = this.$sales.countAtLastPurchasePrice;
        const countAtFuturePurchasePrice = this.$sales.countAtFuturePurchasePrice;
        // const allNewPricesWithoutPennies = this.$sales.allNewPricesWithoutPennies;
        const allClaster = this.$sales.allClaster;
        const individualConfigsObj = Object.create(null);
        const individualCommonConfObj = Object.create(null);

        for (const key in this.$sales.individualSaleConfig) {
            const value = this.$sales.individualSaleConfig[key];
            if (typeof value !== 'undefined' && value !== null) {
                individualConfigsObj[key] = this.prepareIndividualConfig(value);
            }
        }

        for (const key in this.$sales.individualCommonParams) {
            const value = this.$sales.individualCommonParams[key];
            if (typeof value !== 'undefined' && value != null) {
                individualCommonConfObj[key] = this.prepareCommonIndividualConfig(value);
            }
        }

        return {
            xyzChecked: this.$sales.xyzChecked,
            uvwChecked: this.$sales.uvwChecked,
            discountPrise: this.$sales.discountPrice,
            allCheck,
            // pennies,
            countAtLastPurchasePrice,
            countAtFuturePurchasePrice,
            // allNewPricesWithoutPennies,
            allClaster,
            coefficientK1: this.$sales.selectCoefficent.value.k1,
            coefficientK2: this.$sales.selectCoefficent.value.k2,
            category: null,
            storeCluster: null,
            storeClusters: sale.clusters.map(el => el.id).realValuesOrEmpty(),
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            spreadUVWParams: this.$sales.uvwParams,
            spreadXYZParams: this.$sales.xyzParams,
            storeRegionValues: sale.regions.map(el => el.id).realValuesOrEmpty(),
            groupsOfProduct: sale.groups.map(el => el.id).realValuesOrEmpty(),
            categories: sale.categories.map(el => el.id).realValuesOrEmpty(),
            storeFormat: sale.format.id,
            tradingId: sale.tradingId!,
            calculationDepth: +this.$sales.calculationDepth,
            correlation: this.$sales.correlation ? this.$sales.correlation : 0.7,
            highElasticity: this.$sales.highElasticity ? this.$sales.highElasticity : -0.5,
            intervalOfUltimateElasticity: this.$sales.intervalOfUltimateElasticity,
            competitorsPricesParams: this.$sales.competitorsPrices,
            kviStrategy: this.$sales.kviStrategy.value,
            percentageOfCompetitorsPrice: this.$sales.percentageOfCompetitorsPrice,
            marginalProfitability: this.$sales.marginalProfitability,
            marginalProfit: this.$sales.marginalProfit,
            maxMarginalProfit: this.$sales.maxMarginalProfit != null ? this.$sales.maxMarginalProfit : 100,
            marginalPriceDifference: this.$sales.marginalPriceDifference,
            calculationDay: +this.$sales.calculationDay,
            priceCorridor: this.$sales.priceCorridor,
            changePriceCorridor: this.$sales.changePriceCorridor,
            priceIncreaseLimit: this.$sales.priceIncreaseLimit,
            fixLowerBorder: this.$sales.fixLowerBorder,
            individualCommonParams: individualCommonConfObj,
            depthToPurchasePrice: this.$sales.depthToPurchasePrice,
            priceFamilies: this.$sales.priceFamilies,
            hardPriceFamilies: this.$sales.hardPriceFamilies,
            // groupOfProduct: this.$sales.groupOfProduct,
            groupOfProduct: null,
            priceOpt: this.$sales.selectCoefficent.value.enum!,
            subcategories: !sale.subcategory || sale.subcategory.id == null || sale.subcategory.id <= 0 ? null : [sale.subcategory.id],
            // tslint:disable-next-line: no-non-null-assertion
            productSegments: LocalData.filterNumberArrays(this.$sales.productSegments)!!,
            useCompetitorsPrices: this.$sales.useCompetitorsPrices,
            byPromoPrices: this.$sales.byPromoPrices,
            competitorsPricePeriod: this.$sales.competitorsPricePeriod,
            competitorsCodes: this.$sales.competitorsCodes,
            competitorsPriceMethod: this.$sales.competitorsPriceMethod.value,
            competitorsPriceAdjustment: this.$sales.competitorsPriceAdjustment,
            competitorsInfluencesCoef: this.$sales.competitorsInfluencesCoef,
            competitorsMinimumProfit: this.$sales.competitorsMinimumProfit,
            competitorsMaximumProfit: this.$sales.competitorsMaximumProfit != null ? this.$sales.competitorsMaximumProfit : 100,
            competitorsControlParam: this.$sales.competitorsControlParam,
            competitorsPriceStrategy: this.$sales.competitorsPriceStrategy.value,
            // roundKviCompetitorPrice: this.$sales.roundKviCompetitorPrice,
            calculateByRegression: !this.$sales.calculateByElasticity,
            recalculateCtm: this.$sales.recalculateCtm,
            individualPromoConfigs: individualConfigsObj,
            availableStockDelta: this.$sales.availableStockDelta,
            promoInternalCodes: selectedSku,
            lift: this.$sales.lift,
            purchasePrice: this.$sales.purchasePrice,
            crossCalculation: this.$sales.crossCalculation,
            newProductLifespanInDays: this.$sales.newProductLifespanInDays,
            calculateCommon: this.$sales.calculateCommon,
            intervalOfCorrelationElasticity: this.$sales.intervalOfCorrelationElasticity,
            priceChangeLimit: this.$sales.priceChangeLimit,
            priceChangeLimitKvi: this.$sales.priceChangeLimitKvi,
            priceChangeLimitComp: this.$sales.priceChangeLimitComp,
            useBrutForcingParams: false,
            saveAfterOptimize: false,
            optimizationDiff: 0.0,
            calculatePYR: this.$sales.calculatePYR,
            periodPriceIncreaseLimit: this.$sales.periodPriceIncreaseLimit,
            period: this.$sales.period.value,
            newProductPriceStrategy: this.$sales.newProductPriceStrategy.value,
            priceGap: this.$sales.priceGap,
            priceGapCtmPc: this.$sales.priceGapCtmPc,
            findAutomaticallyPriceSegments: false,
            countPriceSegments: 1,
            considerPlannedSeason: this.$sales.considerPlannedSeason,
            useDiscountDurationForForecastCalculation: this.$sales.useDiscountDurationForForecastCalculation,
            useProductRange: this.$sales.useProductRange,
            useSkuRotation: this.$sales.useSkuRotation,
            promoCalc: true,
            percentageOfRecommendsKviCount: this.$sales.percentageOfRecommendsKviCount,
            saveKviSign: this.$sales.saveKviSign,
            useSegmentsPriceInSearchKVIRecParam: this.$sales.useSegmentsPriceInSearchKVIRecParam,
            categoryStrategy: this.$sales.categoryStrategy.value,
            useCompetitorsForKviRecommends: this.$sales.useCompetitorsForKviRecommends,
            competitorsPeriodForKviRecommends: this.$sales.competitorsPeriodForKviRecommends,
            productCodesForAddKvi: [],
            productCodesForDeleteKvi: [],
            productCodesForAddCtmPurpose: [],
            productCodesForDeleteCtmPurpose: [],
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            calculateCompAllowedDeviation: this.$sales.calculateCompAllowedDeviation,
            minProfitKVI: this.$sales.minProfitKVI,
            maxProfitKVI: this.$sales.maxProfitKVI != null ? this.$sales.maxProfitKVI : 100,
            productRangesAndInternalCodes: [],
            // randomPennies: this.$sales.randomPennies,
            excludeOutOfStock: this.$sales.excludeOutOfStock,
            calculateBySalePoints: this.$sales.calculateBySalePoints,
            calculateBySubcategories: this.$sales.calculateBySubcategories,
            trainModel: this.$sales.trainModel,
            considerCannibalization: false,
            useCompElasticity: this.$sales.useCompElasticity,
            // manualPennies: this.$sales.manualPennies,
            forecastAccuracy: this.$sales.forecastAccuracy,
            percentileType: this.$sales.percentileType.value,
            calcWithBatchNumber: false,
            competitorPriceControlParameterPc: this.$sales.competitorPriceControlParameterPc,
            thompsonSampling: false,
            revaluationCalculateParams: this.getDefaultRevaluationCheckParams(),
            inflation: this.$sales.inflation,
            calculateBySpeedSale: this.$sales.calculateBySpeedSale,
            isFixPricePromo: this.$sales.isFixPricePromo,
            spreadByPriceSegments: this.$sales.spreadByPriceSegments,
            rotationPeriodType: this.$sales.rotationPeriodType,
            promoQuote: this.$sales.promoQuoteValue,
            promoPriceCalculationDepth: this.$sales.promoPriceCalculationDepth,
            useCompetitorsPromoPrices: this.$sales.useCompetitorsPromoPrices,
            calculateCompAllowedDeviationPromo: this.$sales.calculateCompAllowedDeviationPromo,
            competitorPriceControlParameterPcPromo: this.$sales.competitorPriceControlParameterPcPromo,
            competitorsPricePeriodPromo: this.$sales.competitorsPricePeriodPromo,
            competitorsPromoPriceInfluencesCoef: this.$sales.competitorsPromoPriceInfluencesCoef,
            percentileTypePromo: this.$sales.percentileTypePromo,
            competitorsPromoPriceAdjustment: this.$sales.competitorsPromoPriceAdjustment,
            competitorsControlPromoParam: this.$sales.competitorsControlPromoParam,
            competitorsPromoPriceMethod: this.$sales.competitorsPromoPriceMethod.value,
            competitorsMinimumProfitPromo: this.$sales.competitorsMinimumProfitPromo,
            competitorsMaximumProfitPromo: this.$sales.competitorsMaximumProfitPromo != null ? this.$sales.competitorsMaximumProfitPromo : 100,
            competitorsPromoPriceStrategy: this.$sales.competitorsPromoPriceStrategy.value,
            planningPromoPeriodStartDate:
                !!sale.startDate
                    ? moment.utc(sale.startDate).startOf('day').valueOf()
                    : null,
            planningPromoPeriodEndDate:
                !!sale.endDate
                    ? moment.utc(sale.endDate).startOf('day').valueOf()
                    : null,
            minDefaultDiscount: sale.minSaleDiscount || 0,
            maxDefaultDiscount: sale.maxSaleDiscount || 0,
            priceDecreaseLimit: this.$sales.priceDecreaseLimit,
            minPromoPrice: this.$sales.minPromoPrice,
        };
    }

    getSaleTypeLabel(typeValue: string | null = null) {
        const typeObj = this.saleTypeOptions.find(option => option.value === typeValue);

        return typeObj ? typeObj.label : (this.$t('salesListTab.messages.unknownType') as string);
    }
}
